<div class="progress-container">
    <div class="progress-bar" [ngStyle]="{ 'width': progress + '%' }"></div>
    <div class="progress-text">{{ progress }}%</div>
  </div>
  